<template>
    <div class="content">
        <!-- <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">安全巡查隐患整改</h3> -->
        <div  class="pageHeader">
            <el-tabs v-model="activeName" @tab-click="handleTabClick">
                <el-tab-pane label="智能锁授权" name="1">
                </el-tab-pane>
                <el-tab-pane label="授权申请记录" name="2">
                </el-tab-pane>
            </el-tabs>
        </div>
        <div v-if="activeName == '1'">
            <SmarktLockApplyTab1 />
        </div>
        <div v-if="activeName == '2'">
            <SmarktLockApplyTab2 />
        </div>
    </div>
</template>

<script>

import SmarktLockApplyTab1 from "./smarktLockApplyTab1";
import SmarktLockApplyTab2 from "./smarktLockApplyTab2";
export default {
    name: 'equipmentInto',
    data() {
        return {
            activeName: '1',
        };
    },
    components: {
        SmarktLockApplyTab1,
        SmarktLockApplyTab2
    },
    created() {
    },
    mounted() {
    },
    methods: {
        handleTabClick(val) {
        },
    },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
    width: var(--width);
}
.pageHeader {
    padding-bottom: 5px;
}
</style>